"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBaseLoginContext = void 0;
var _react = _interopRequireDefault(require("react"));
const useBaseLoginContext = () => {
  return _react.default.useCallback(function (loginMethod) {
    let client = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "web";
    return {
      client,
      login_method: loginMethod
    };
  }, []);
};
exports.useBaseLoginContext = useBaseLoginContext;